import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/content/content-item-render";
import { Button } from "~/components/posties/button";
import type { postiesSecondaryContentItemContent$key } from "~/queries/__generated__/postiesSecondaryContentItemContent.graphql";
import type { CustomQueryParameters } from "~/types/gtm";

import {
  Container,
  Content,
  Cover,
  Headline,
  StyledContentCoverImage,
  StyledEntityLink,
} from "./styles";

export type Props = {
  className?: string;
  customQueryParameters?: CustomQueryParameters;
  provider: DefaultComponentsProvider;
  reference: postiesSecondaryContentItemContent$key;
};

export const ContentItemPostiesSecondary = forwardRef<HTMLDivElement, Props>(
  ({ className, customQueryParameters, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment postiesSecondaryContentItemContent on Content {
          ...entityLink
          ...contentCoverImageContent
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink query={customQueryParameters} reference={content}>
          <Cover>
            <StyledContentCoverImage
              reference={content}
              responsiveVariants={{
                desktopUp: "size540x360",
                mobileUp: "size540x360",
                tabletUp: "size540x360",
              }}
            />
          </Cover>
          <Content>
            <Headline>
              {provider.headline({
                hideTag: true,
                preferSocialHeadline: true,
              })}
            </Headline>
            <Button variant="button">READ MORE</Button>
          </Content>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemPostiesSecondary.displayName = "ContentItemPostiesSecondary";
